import { ref } from 'vue';
import axios from 'axios';
import { route } from 'ziggy-js';

const isPluginSubscribed = ref(false);
const hasAnyProSubscriptionOrTrial = ref(true);
const isProSubscribedOrTrialing = ref(true);
const isProSubscribed = ref(true);

export const useSubscriptions = () => {
    const fetchSubscriptions = async () => {
        try {
            const res = await axios.get(route('user.subscriptions.index'));

            if (res.data.success) {
                isPluginSubscribed.value = res.data.data.isPluginSubscribed;
                hasAnyProSubscriptionOrTrial.value =
                    res.data.data.hasAnyProSubscriptionOrTrial;
                isProSubscribedOrTrialing.value =
                    res.data.data.isProSubscribedOrTrialing;
                isProSubscribed.value = res.data.data.isProSubscribed;
            }
        } catch (err) {
            return;
        }
    };

    return {
        fetchSubscriptions,
        isPluginSubscribed,
        isProSubscribed,
        isProSubscribedOrTrialing,
        hasAnyProSubscriptionOrTrial,
    };
};

export default useSubscriptions;
